import { Table } from '@quero-delivery/quero-components-web';
import { format } from '@querodelivery/qd-date-helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import styles from './styles.module.scss';
import { centsToMoneyLabel } from '@/Utils/FnUtils';
import { colors } from '@/Themes/Colors';
import type { Ticket } from '@/_features/places/types';

type Props = {
  tickets?: Ticket[];
};

export const TicketTable = ({ tickets }: Props) => {
  return (
    <>
      {tickets && tickets.length > 0 ? (
        <>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Valor do Boleto</Table.HeaderCell>
              <Table.HeaderCell>Valor Pago</Table.HeaderCell>
              <Table.HeaderCell>Vencimento</Table.HeaderCell>
              <Table.HeaderCell>Pago em</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {tickets.map(ticket => (
              <Table.Row key={ticket._id}>
                <Table.Cell>{centsToMoneyLabel(ticket.valorCents)}</Table.Cell>
                <Table.Cell>
                  {centsToMoneyLabel(ticket.totalPaidCents)}
                </Table.Cell>
                <Table.Cell>
                  {ticket.dataVencimento
                    ? format(ticket.dataVencimento, 'dd/MM/yyyy')
                    : ''}
                </Table.Cell>
                <Table.Cell>
                  {ticket.pagoAt ? format(ticket.pagoAt, 'dd/MM/yyyy') : '---'}
                </Table.Cell>
                <Table.Cell>{ticket.status}</Table.Cell>
                <Table.Cell>
                  <div
                    className={styles.iconDownload}
                    onClick={() => window.open(ticket.urlBoleto)}
                  >
                    <FontAwesomeIcon icon={faDownload} color={colors.white} />
                  </div>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </>
      ) : (
        <span className="body2">Nenhum boleto encontrado</span>
      )}
    </>
  );
};
